import React, { Component } from 'react';
import { Link } from "react-router-dom";

class FestivalSE extends Component {
  componentDidMount() {
    window.startx();
  }
  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Festival Escolar por el Bienestar Socioemocional</h2>
          </header>
          <div className="containerimagenblog">
            <img className="imagenBlog" src="images/Blog/portada2.jpg" alt="Dia Naranja" />
          </div>
          <span className="containerblog">
            <div className="align justify">
              <p>
                El Museo Interactivo El Rehilete fue sede del Festival Escolar por el Bienestar Socioemocional.
                El evento fue encabezado por el secretario de Educación Pública de Hidalgo, <b>Naty Castrejón</b> acompañado por nuestra 
                directora general, <b>Jerusalem Kuri del Campo</b>, así como autoridades de diferentes ámbitos, entre ellas
                <b>Óscar “El Conejo” Pérez</b>, Director del Instituto Hidalguense del Deporte, junto con maestras, maestros, estudiantes y familias.
               

              </p>
              <p>
                 Este encuentro, enmarcado en la Estrategia Nacional de Vida Saludable Vive feliz, impulsa la empatía, la inteligencia emocional, el 
                 autocuidado y la sana convivencia.
                

              </p>
              <p>
                <b>En El Rehilete nos enorgullece ser un espacio donde la educación, la ciencia y las emociones se encuentran.</b>
              </p>
              
            </div>
            <div className="containerimagenBlogmini">
              <img className="imagenBlogmini" src="images/Blog/festivalse1.jpg" alt="Festival1" />
              <img className="imagenBlogmini" src="images/Blog/festivalse2.jpg" alt="Festival2" />
              <img className="imagenBlogmini" src="images/Blog/festivalse3.jpg" alt="Festival3" />
               <img className="imagenBlogmini" src="images/Blog/festivalse4.jpg" alt="Festival4" />
              </div>
            <div>
              <div className="containerjuego">
                 <Link className="button" to="/blog">
                Regresar
              </Link>
              </div>
            </div>
          </span>
        </div>
      </div>
    );
  }
}

export default FestivalSE;